import React, { PropTypes } from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { SelectInput } from "../../../../../common/form";
import { FormattedMessage, intlShape } from "react-intl";

class BillingPeriodField extends React.Component {
  generateBillingPeriodOptions() {
    const { formatDate, formatMessage } = this.context.intl;
    const { billingPeriods } = this.props;
    const dateFormat = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      timeZone: "utc",
    };

    return billingPeriods.map((billingPeriod) => {
      const startDate = formatDate(billingPeriod.startDate, dateFormat);
      const endDate = formatDate(billingPeriod.endDate, dateFormat);
      const billingPeriodName =
        billingPeriod.localizations[this.props.authLanguageCode].name;
      return {
        value: billingPeriod.billingPeriodId,
        text: `${billingPeriodName} (${startDate} ${formatMessage({
          id: "common.toDate",
        })} ${endDate})`,
      };
    });
  }

  render() {
    return (
      <div>
        <Field
          component={SelectInput}
          sortOptions={false}
          options={this.generateBillingPeriodOptions()}
          addBlankOption={true}
          label={
            <FormattedMessage id="clients.client.reports.dependentPersonCoveragesTerminations.form.billingPeriod" />
          }
          {...this.props}
        />
      </div>
    );
  }
}

BillingPeriodField.contextTypes = {
  intl: intlShape,
};
BillingPeriodField.propTypes = {
  billingPeriods: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  authLanguageCode: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    authLanguageCode: state.auth.user.languageCode,
  };
}

export default connect(mapStateToProps)(BillingPeriodField);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/reports/forms/BillingPeriodField.js